document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.header__inline-menu details');
  
  menuItems.forEach(item => {
    item.addEventListener('mouseover', () => {
      item.setAttribute('open', 'true');
    });
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
    const submenu = item.querySelector('.header__submenu');
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        item.setAttribute('open', 'true');
      });
      submenu.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
    }
  });
});